import PropTypes from 'prop-types';
import React from 'react';

import {pushInteractionTagManager} from '../../../services/tagManager';
import './Modal.style.scss';

const getModalClassName = (modalSize) => {
  if (modalSize === 'medium') return 'reusable-modal__content-medium';
  if (modalSize === 'small') return 'reusable-modal__content-small';
  return 'reusable-modal__content';
};

export const Modal = (props) => {
  const closeModal = () => {
    if (props.typeModal === 'accreditation') {
      pushInteractionTagManager({
        elementContent: 'none:fechar:none',
        elementType: 'select:icon:click',
        screenName: 'credenciamento:modal'
      });
    }
    props.showModalFunction();
  };

  const closeModalFromBackground = (event) => {
    if (props.disableExternalClick) return;
    if (event.target.id === 'background-modal') {
      closeModal();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape' && !props.disableExternalClick) {
      closeModal();
    }
  };

  return (
    <>
      {props.showModal && (
        <dialog
          open
          aria-modal="true"
          data-testid="reusable-modal"
          className="reusable-modal"
          onKeyDown={handleKeyDown}
        >
          <div
            id="background-modal"
            className="reusable-modal__backdrop"
            onMouseDown={closeModalFromBackground}
          >
            <div className={getModalClassName(props.modalSize)}>
              {props.typeCloseButton === undefined && (
                <button
                  data-testid="btn-close-modal"
                  className="reusable-modal__button reusable-modal__button--close"
                  onClick={closeModal}
                >
                  <span>&times;</span>
                </button>
              )}

              {props.typeCloseButton === 'circle' && (
                <button
                  data-testid="btn-close-modal-circle"
                  className="circular-close-button"
                  onClick={closeModal}
                >
                  <span>&times;</span>
                </button>
              )}

              {props.children}
            </div>
          </div>
        </dialog>
      )}
    </>
  );
};

Modal.propTypes = {
  children: PropTypes.element,
  showModal: PropTypes.bool,
  showModalFunction: PropTypes.func,
  typeModal: PropTypes.string,
  modalSize: PropTypes.string,
  typeCloseButton: PropTypes.string,
  disableExternalClick: PropTypes.bool
};
